import { r4Client, r4Error } from '@/services'

const DatasourceMailerApi = {

  async fetchDatasourceMailers () {
    try {
      const resp = await r4Client().get('/api/v1/datasource_mailers')
      return resp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async fetchDatasourceMailer (datasourceMailerId) {
    try {
      const resp = await r4Client().get(`/api/v1/datasource_mailers/${datasourceMailerId}`)
      return resp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async fetchDatasourceMailerAttachment (datasourceMailerId, attachmentId) {
    try {
      const resp = await r4Client().get(`/api/v1/datasource_mailers/${datasourceMailerId}/attachments/${attachmentId}`)
      return resp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async fetchDatasourceMailerAttachmentDownloadUrl (datasourceMailerId, attachmentId) {
    try {
      const downloadResp = await r4Client().get(`/api/v1/datasource_mailers/${datasourceMailerId}/attachments/${attachmentId}/download`)
      return downloadResp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async createDatasourceMailer (datasourceMailer) {
    try {
      const resp = await r4Client().post('/api/v1/datasource_mailers', datasourceMailer)
      return resp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async updateDatasourceMailer (datasourceMailer) {
    try {
      const resp = await r4Client().put(`/api/v1/datasource_mailers/${datasourceMailer.id}`, datasourceMailer)
      return resp.data.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async saveDatasourceMailer (datasourceMailer) {
    try {
      const savePromise = datasourceMailer.id
        ? this.updateDatasourceMailer(datasourceMailer)
        : this.createDatasourceMailer(datasourceMailer)

      const resp = await savePromise
      return resp
    } catch (error) {
      throw r4Error(error)
    }
  },

  async deleteDatasourceMailer (datasourceMailerId) {
    try {
      await r4Client().delete(`/api/v1/datasource_mailers/${datasourceMailerId}`)
      return true
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default DatasourceMailerApi
